require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./loans-and-credit-cards-overdraft-line-of-credit.json") })
        }
      }, "path---loans-and-credit-cards-overdraft-line-of-credit");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---loans-and-credit-cards-overdraft-line-of-credit!./.cache/json/loans-and-credit-cards-overdraft-line-of-credit.json
// module id = 2657
// module chunks = 231608221292675